<template>
	<v-sheet
		v-if="length(items) > 1"
		color="grey lighten-4"
		class="mb-4"
		elevation="0"
		rounded>
		<v-breadcrumbs :items="items">
			<template #item="{ item }">
				<li>
					<Link v-if="! item.disabled" :href="item.href" class="v-breadcrumbs__item">
						{{ item.text }}
						<span v-if="item.id">&nbsp;(#{{ item.id }})</span>
					</Link>

					<span v-else class="v-breadcrumbs__item v-breadcrumbs__item--disabled">
						{{ item.text }}
						<span v-if="item.id">&nbsp;(#{{ item.id }})</span>
					</span>
				</li>
			</template>
		</v-breadcrumbs>
	</v-sheet>
</template>
<script>
export default {
	props: {
		breadcrumbs: {
			type: Array,
			default: () => {
				return [
					{ route: 'dashboard', label: 'Dashboard' }
				]
			}
		}
	},
	data () {
		return {
			//
		}
	},
	computed: {
		items () {
			let items = []

			for (const breadcrumbsKey in this.breadcrumbs) {
				if (!this.breadcrumbs.hasOwnProperty(breadcrumbsKey)) continue
				const crumb = this.breadcrumbs[breadcrumbsKey]
				const params = crumb.hasOwnProperty('params')
					? crumb.params
					: []

				const route = crumb.hasOwnProperty('route')
					? this.route(crumb.route, params)
					: null

				items.push({
					text: crumb.label,
					id: crumb.hasOwnProperty('id') ? crumb.id : null,
					href: route,
					disabled: !route
				})
			}

			return items
		}
	}
}
</script>
